import fetch from "isomorphic-unfetch";

export default async function useFetch(...args) {
  const res = await fetch(...args);
  return res.json();
}
